'use client';

import { PlugZap } from 'lucide-react';

import { Button, Card } from '@/components/ui';
import { theme } from '@/lib/ui/theme';

/**
 * SignInUnavailable is the terminal state for a session whose authentication client never becomes
 * usable — its script blocked by an extension or a content-security-policy gap, or a load that
 * neither completes nor errors.
 *
 * Without it those conditions hold the dashboard's loading gate true forever, which is the same
 * stranded page this surface exists to prevent, reached through the one term the store's deadline
 * cannot bound. Reloading is the only recovery the page can offer, since every richer action needs
 * the client that is missing.
 */
export function SignInUnavailable() {
  return (
    <Card className="border-primary/20 mx-auto max-w-md">
      <div className="flex flex-col items-center gap-4 py-2 text-center">
        <div className="bg-primary/10 text-primary flex h-12 w-12 items-center justify-center rounded-full">
          <PlugZap className="h-6 w-6" />
        </div>
        <div className="space-y-1.5">
          <h2
            className="text-xl font-semibold"
            style={{ fontFamily: theme.fonts.body }}
          >
            Can&rsquo;t reach sign-in
          </h2>
          <p
            className="text-muted-foreground text-sm"
            style={{ fontFamily: theme.fonts.body }}
          >
            Your browser couldn&rsquo;t load our sign-in service. An ad blocker,
            a privacy extension, or a restricted network will do this. Allow{' '}
            <span className="font-medium">clerk.com</span> and reload.
          </p>
        </div>
        <Button
          onClick={() => window.location.reload()}
          data-testid="retry-sign-in"
        >
          Reload
        </Button>
      </div>
    </Card>
  );
}
